import { useInvalidateMyDesigns } from '@/entities/my-design';
import { trpc } from '@/shared/api';

/** 내 디자인 이름만 바꾸기(designs.rename) — 본문·수정일은 그대로라 자리도 썸네일도 유지된 채 이름만 바뀐다. */
export const useRenameMyDesign = () => {
  const invalidate = useInvalidateMyDesigns();
  const mutation = trpc.designs.rename.useMutation();
  return {
    rename: async (designId: string, name: string): Promise<void> => {
      await mutation.mutateAsync({ id: designId, name });
      await invalidate();
    },
    isPending: mutation.isPending,
  };
};
